import { ClipboardCheck } from "lucide-react";

import { Badge } from "@/components/ui/badge";

import {
  REQUIREMENT_ITEMS,
  answeredCount,
  requirementsStatus,
  type RequirementsRecord,
} from "./requirements";

/** Compact state of the standard installation requirements for cards. */
export const RequirementsBadge = ({
  record,
}: {
  record: RequirementsRecord;
}) => {
  const status = requirementsStatus(record);
  if (status === "approved") {
    return (
      <Badge
        className="gap-1 border-transparent bg-emerald-100 text-emerald-800 dark:bg-emerald-400/15 dark:text-emerald-200"
        title="Instalación estándar aprobada"
      >
        <ClipboardCheck className="h-3 w-3" />
        Estándar OK
      </Badge>
    );
  }
  if (status === "not_standard") {
    return (
      <Badge variant="destructive" className="gap-1">
        <ClipboardCheck className="h-3 w-3" />
        No estándar
      </Badge>
    );
  }
  if (status === "to_review") {
    return (
      <Badge
        className="gap-1 border-transparent bg-amber-100 text-amber-900 dark:bg-amber-400/15 dark:text-amber-200"
        title="Requisitos confirmados: falta revisarlos y aprobarlos"
      >
        <ClipboardCheck className="h-3 w-3" />
        Requisitos por revisar
      </Badge>
    );
  }
  return (
    <Badge
      variant="outline"
      className="gap-1"
      title="Requisitos de instalación confirmados con el cliente"
    >
      <ClipboardCheck className="h-3 w-3" />
      Requisitos {answeredCount(record)}/{REQUIREMENT_ITEMS.length}
    </Badge>
  );
};
